import { Typography } from "@mui/material";

const AuthenticationLoading = () => {
  return <Typography>Authentication in progress...</Typography>;
};
export default AuthenticationLoading;
